module.exports = __webpack_public_path__ + "static/bowser-e9db88379483a4e3a498f43dae4e299f.png";